<template>
  <div class="login-wrap">
    <div class="login-cont">
      <div class="cont">
        <img src="@/assets/images/logo.svg" alt="">
        <h1>로그인</h1>
        <p>이미 가입된 뷰저블 통합 아이디로 <br>이용하실 수 있습니다!</p>
        <input-text
          :title="'아이디'"
          :baseText="'이메일'"
          :contList="modelError.username ? 'login error' : 'login'"
          @input="getUserName"
          @submit="onSubmit"
          :errorText="modelError.username" />

        <input-text
          :type="'password'"
          :title="'비밀번호'"
          :baseText="'비밀번호'"
          :contList="modelError.password ? 'login error' : 'login'"
          :errorText="modelError.password"
          @input="getPassword"
          @submit="onSubmit" />
        <button-item :btnText="'로그인'" :btnClass="'login'" @click="onSubmit"/>
        <div class="register-wrap">
<!--          <span>Register</span>-->
<!--          <span>Forgot password</span>-->
        </div>
      </div>
      <div class="copylight">
        <p>Copyright © 2021 4Grit. All rights reserved.</p>
        <a href="privacy" target="_blank">개인정보취급방침</a>
        <span class="mid-dot"></span>
        <a href="term" target="_blank">Terms of Service</a>
      </div>
    </div>
    <div class="visual-wrap">
      <img src="@/assets/images/visual-login.svg" alt="">
    </div>
  </div>
</template>

<script>
import { setAuthData } from '@/libs/auth-helper'
import { signIn } from '@/api/user'
import { create } from 'vue-modal-dialogs'

import { ERROR_MSG, HTTP_STATUS } from '@/libs/constants'

import InputText from '@/components/ui/InputText'
import ButtonItem from '@/components/ui/button'

import IeWarningPopup from '@/components/layerpop/IeWarningPopup'
import { browserInfo } from '@/libs/utils'

const ieWaringLayer = create(IeWarningPopup)

export default {
  name: 'SignIn',
  components: {
    InputText,
    ButtonItem
  },
  data () {
    return {
      model: {
        username: '',
        password: ''
      },
      modelError: {
        username: '',
        password: ''
      },
      auth: {
        key: '',
        value: ''
      }
    }
  },
  async mounted () {
    if (browserInfo.name && browserInfo.name === 'ie') {
      await ieWaringLayer()
    }
  },
  computed: {
    canSubmit () {
      return this.model.username.length && this.model.password.length && this.model.password.length >= 6
    }
  },
  methods: {
    getUserName (value) {
      this.model.username = value
    },
    getPassword (value) {
      this.model.password = value
    },
    getAuthParam () {
      let param = window.location.search
      if (param.indexOf('reset_password') > -1) {
        param = param.split('&')
        param = param[1].split('=')
        this.auth.key = param[0].substring(0, param[0].length)
        this.auth.value = param[1]
      } else {
        param = param.split('=')
        this.auth.key = param[0].substring(1, param[0].length)
        this.auth.value = param[1]
      }

      if (this.auth.value === 'signup_key_expired' || this.auth.value === 'signup_ok') {
        this.isEnteredSignUpAuthEmail = true
      } else if (this.auth.value === 'not_found_reset_key' || this.auth.value === 'reset_key_expired' || this.auth.key === 'key') {
        this.isEnteredResetPasswordAuthEmail = true
      } else if (this.auth.value === 'invalid_param') {
        this.invalidParam = true
      }
    },
    onSubmit () {
      console.log('1111111')
      this.modelError.username = ''
      this.modelError.password = ''

      if (!this.canSubmit) {
        if (!this.model.username.length) {
          this.modelError.username = ERROR_MSG.username.empty
        }
        if (!this.model.password.length) {
          this.modelError.password = ERROR_MSG.password.empty
        } else if (this.model.password.length < 6) {
          this.modelError.password = ERROR_MSG.password.length
        }
        return
      }

      signIn(this.model).then(data => {
        setAuthData(data)
        this.$router.replace({ name: 'dashboard' })
      }).catch(err => {
        if (err.message === 'user id not found') {
          this.modelError.username = ERROR_MSG.username.notfound
        }
        if (err.message === 'Unactivated user') {
          this.modelError.username = ERROR_MSG.username.unactivated
        }
        if (err.message === 'Unable user' || err.message === 'No current credit found') {
          this.modelError.username = ERROR_MSG.username.unable
        }
        if (err.message === 'Wrong password') {
          this.modelError.password = ERROR_MSG.password.wrong
        }
        if (err.response && err.response.status) {
          if (err.response.status === HTTP_STATUS.badRequest) {
            this.modelError.password = 'Check username or password'
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.login-wrap {
  .login-cont {
    position: fixed;
    top: 7px;
    bottom: 7px;
    left: 8px;
    width: 340px;
    background: #fff;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    -webkit-box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    overflow: auto;
    border-radius: 14px;
    padding: 0 40px;
    box-sizing: border-box;
    .cont {
      width: 260px;
      position: absolute;
      top: calc(50% - 5vh);
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);

        box-sizing: border-box;
      & > img {
        margin-left: 5px;
      }
      h1 {
        font-size: 50px;
        font-weight: 500;
        color: #555;
        margin: 10px 0 20px;
      }
      p {
        font-size: 13px;
        line-height: 1.46;
        color: #666;
        margin: 0 0 30px;
        padding-left: 5px;
        box-sizing: border-box;
      }
      & > .register-wrap {
        margin-top: 20px;
        text-align: center;
        span {
          font-size: 13px;
          font-weight: 500;
          line-height: 1.46;
          color: #666;
          margin-right: 20px;
          cursor: pointer;
          &:last-child {
            position: relative;
            margin-right: 0;
            &::after {
              content: "";
              position: absolute;
              top: 50%;
              left: -11px;
              transform: translateY(-50%);
              width: 1px;
              height: 12px;
              background: #d7d7d7;
            }
          }
        }
      }
    }
    & > .copylight {
      position: absolute;
      left: 40px;
      bottom: 30px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      color: #666;
      p {
        margin-bottom: 10px;
      }
      a {
        list-style: none;
        color: #666;
        display: inline-block;
      }
      span {
        display: inline-block;
        width: 3px;
        height: 3px;
        vertical-align: middle;
        margin-left: 6px;
        margin-right: 6px;
        background-color: #aaa;
      }
    }
  }
  & > .visual-wrap {
    position: absolute;
    right: 0;
    top: 50%;
    z-index: -1;
    transform: translateY(-50%);
    width: calc(100% - 350px);
    text-align: center;
  }
}
</style>
